export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const getActionBadgeClass = (action) => {
  const act = String(action || "").toUpperCase();
  if (act.includes("CANCEL")) return "bg-danger";
  if (act.includes("REFUND")) return "bg-warning text-dark";
  if (act.includes("BOOKING") || act.includes("CREATE") || act.includes("SUCCESS")) return "bg-success";
  if (act.includes("UPDATE") || act.includes("EDIT")) return "bg-primary";
  if (act.includes("DELETE") || act.includes("REMOVE")) return "bg-dark";
  return "bg-secondary";
};

export const formatLocation = (loc) => {
  if (!loc) return "-";
  const parts = [loc.city, loc.region, loc.country].filter(Boolean);
  return parts.join(", ") || "-";
};
